import { defineFakeRoute } from 'vite-plugin-fake-server/client'

export default defineFakeRoute([
  {
    url: '/mock/get/currentlyEffect/list',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          page: 1,
          pageSize: 10,
          finished: true,
          list: [
            {
              stockName: '福耀玻璃',
              stockCode: '600660',
              inDate: '2024-06-17',
              latestChangeRate: 1.25,
              cumulativeChangeAmount: 8.36,
              outStockName: '国电南瑞',
              outStockCode: '600406',
              potential: 1,
              reason: '市值增长及行业代表性提升',
            },
            {
              stockName: '先导智能',
              stockCode: '300450',
              inDate: '2024-06-17',
              latestChangeRate: -0.82,
              cumulativeChangeAmount: -5.12,
              outStockName: '汇川技术',
              outStockCode: '300124',
              potential: 0,
              reason: '新能源装备行业龙头地位巩固',
            },
            {
              stockName: '万华化学',
              stockCode: '600309',
              inDate: '2024-06-17',
              latestChangeRate: 2.17,
              cumulativeChangeAmount: 12.45,
              outStockName: '荣盛石化',
              outStockCode: '002493',
              potential: 1,
              reason: '化工行业景气度回升带动市值增长',
            },
            {
              stockName: '兆易创新',
              stockCode: '603986',
              inDate: '2024-06-17',
              latestChangeRate: -1.36,
              cumulativeChangeAmount: -7.89,
              outStockName: '韦尔股份',
              outStockCode: '603501',
              potential: 1,
              reason: '半导体存储领域市场份额扩大',
            },
            {
              stockName: '德赛西威',
              stockCode: '002920',
              inDate: '2024-06-17',
              latestChangeRate: 0.94,
              cumulativeChangeAmount: 5.67,
              outStockName: '华域汽车',
              outStockCode: '600741',
              potential: 0,
              reason: '智能驾驶业务快速发展',
            },
            {
              stockName: '爱美客',
              stockCode: '300896',
              inDate: '2024-06-17',
              latestChangeRate: 3.21,
              cumulativeChangeAmount: 18.76,
              outStockName: '华熙生物',
              outStockCode: '688363',
              potential: 0,
              reason: '医美行业龙头地位进一步巩固',
            },
          ],
        },
      }
    },
  },
  {
    url: '/mock/get/currentlyFind/list',
    method: 'post',
    response: ({ body }) => {
      const stockFundFlowList = [
        {
          stockName: '腾讯控股',
          stockCode: '00700.HK',
          inDate: '2024-06-17',
          rate: 2.45,
          fund: 1.85,
          num: 12,
          type: 1,
          data: 1,
        },
        {
          stockName: '美团-W',
          stockCode: '03690.HK',
          inDate: '2024-06-18',
          rate: -1.12,
          fund: -0.45,
          num: 8,
          type: 2,
          data: 2,
        },
        {
          stockName: '阿里巴巴-SW',
          stockCode: '09988.HK',
          inDate: '2024-06-17',
          rate: 0.85,
          fund: 0.92,
          num: 5,
          type: 3,
          data: 1,
        },
        {
          stockName: '药明生物',
          stockCode: '02269.HK',
          inDate: '2024-06-19',
          rate: 3.56,
          fund: 1.20,
          num: 15,
          type: 1,
          data: 3,
        },
        {
          stockName: '比亚迪股份',
          stockCode: '01211.HK',
          inDate: '2024-06-17',
          rate: 4.20,
          fund: 2.15,
          num: 7,
          type: 2,
          data: 1,
        },
        {
          stockName: '快手-W',
          stockCode: '01024.HK',
          inDate: '2024-06-18',
          rate: 2.35,
          fund: 0.68,
          num: 9,
          type: 3,
          data: 2,
        },
        {
          stockName: '中芯国际',
          stockCode: '00981.HK',
          inDate: '2024-06-19',
          rate: 1.45,
          fund: 0.75,
          num: 3,
          type: 1,
          data: 1,
        },
        {
          stockName: '京东集团-SW',
          stockCode: '09618.HK',
          inDate: '2024-06-17',
          rate: 0.55,
          fund: 0.32,
          num: 4,
          type: 2,
          data: 3,
        },
        {
          stockName: '恒生电子',
          stockCode: '06037.HK',
          inDate: '2024-06-18',
          rate: 0.95,
          fund: 0.25,
          num: 6,
          type: 3,
          data: 1,
        },
        {
          stockName: '网易-S',
          stockCode: '09999.HK',
          inDate: '2024-06-19',
          rate: 1.10,
          fund: 0.58,
          num: 2,
          type: 1,
          data: 2,
        },
        {
          stockName: '中国海洋石油',
          stockCode: '00883.HK',
          inDate: '2024-06-17',
          rate: 2.15,
          fund: 1.42,
          num: 11,
          type: 2,
          data: 1,
        },
        {
          stockName: '建设银行',
          stockCode: '00939.HK',
          inDate: '2024-06-18',
          rate: 0.35,
          fund: 0.85,
          num: 20,
          type: 3,
          data: 2,
        },
        {
          stockName: '理想汽车-W',
          stockCode: '02015.HK',
          inDate: '2024-06-19',
          rate: 4.12,
          fund: 2.10,
          num: 14,
          type: 1,
          data: 3,
        },
        {
          stockName: '百度集团-SW',
          stockCode: '09888.HK',
          inDate: '2024-06-17',
          rate: 1.65,
          fund: 0.72,
          num: 5,
          type: 2,
          data: 1,
        },
        {
          stockName: '安踏体育',
          stockCode: '02020.HK',
          inDate: '2024-06-18',
          rate: 1.45,
          fund: 0.38,
          num: 8,
          type: 3,
          data: 2,
        },
        {
          stockName: '中国移动',
          stockCode: '00941.HK',
          inDate: '2024-06-20',
          rate: 0.45,
          fund: 3.12,
          num: 18,
          type: 1,
          data: 2,
        },
        {
          stockName: '海底捞',
          stockCode: '06862.HK',
          inDate: '2024-06-20',
          rate: -2.15,
          fund: -0.85,
          num: 6,
          type: 2,
          data: 1,
        },
        {
          stockName: '龙湖集团',
          stockCode: '00960.HK',
          inDate: '2024-06-21',
          rate: -5.42,
          fund: -1.45,
          num: 22,
          type: 3,
          data: 3,
        },
        {
          stockName: '联想集团',
          stockCode: '00992.HK',
          inDate: '2024-06-20',
          rate: 3.18,
          fund: 1.25,
          num: 9,
          type: 1,
          data: 1,
        },
        {
          stockName: '华润啤酒',
          stockCode: '00291.HK',
          inDate: '2024-06-21',
          rate: 1.25,
          fund: 0.55,
          num: 4,
          type: 2,
          data: 2,
        },
        {
          stockName: '商汤-W',
          stockCode: '00020.HK',
          inDate: '2024-06-20',
          rate: -1.85,
          fund: -2.10,
          num: 35,
          type: 3,
          data: 1,
        },
        {
          stockName: '舜宇光学科技',
          stockCode: '02382.HK',
          inDate: '2024-06-21',
          rate: 2.76,
          fund: 0.88,
          num: 7,
          type: 1,
          data: 3,
        },
        {
          stockName: '汇丰控股',
          stockCode: '00005.HK',
          inDate: '2024-06-20',
          rate: 0.15,
          fund: 4.50,
          num: 12,
          type: 2,
          data: 1,
        },
        {
          stockName: '小鹏汽车-W',
          stockCode: '09868.HK',
          inDate: '2024-06-21',
          rate: -3.22,
          fund: -1.15,
          num: 16,
          type: 3,
          data: 2,
        },
        {
          stockName: '信义光能',
          stockCode: '00968.HK',
          inDate: '2024-06-20',
          rate: 1.42,
          fund: 0.36,
          num: 5,
          type: 1,
          data: 1,
        },
      ]
      const list = stockFundFlowList.filter(each => each.type === body.type && each.data === body.data)
      return {
        error: '',
        status: 1,
        data: {
          page: 1,
          pageSize: 10,
          finished: true,
          list,
        },
      }
    },
  },
  {
    url: '/mock/get/market/overview',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          shIndex: { name: '上证指数', code: '000001', price: 3245.67, change: 12.34, changeRate: 0.38 },
          szIndex: { name: '深证成指', code: '399001', price: 12345.89, change: -23.45, changeRate: -0.19 },
          cybIndex: { name: '创业板指', code: '399006', price: 2567.12, change: 8.90, changeRate: 0.35 },
        },
      }
    },
  },
  {
    url: '/mock/get/market/hotStocks',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          page: 1,
          pageSize: 10,
          finished: true,
          list: [
            { name: '宁德时代', code: '300750', price: 198.50, change: 5.20, changeRate: 2.69, volume: '125.6亿' },
            { name: '比亚迪', code: '002594', price: 245.80, change: -3.20, changeRate: -1.29, volume: '98.3亿' },
            { name: '贵州茅台', code: '600519', price: 1688.00, change: 12.50, changeRate: 0.75, volume: '156.2亿' },
            { name: '五粮液', code: '000858', price: 156.30, change: 2.10, changeRate: 1.36, volume: '87.5亿' },
            { name: '中国平安', code: '601318', price: 48.90, change: 0.85, changeRate: 1.77, volume: '112.3亿' },
            { name: '招商银行', code: '600036', price: 42.15, change: -0.25, changeRate: -0.59, volume: '89.7亿' },
            { name: '美的集团', code: '000333', price: 58.60, change: 1.20, changeRate: 2.09, volume: '76.4亿' },
            { name: '格力电器', code: '000651', price: 36.80, change: -0.50, changeRate: -1.34, volume: '65.2亿' },
          ],
        },
      }
    },
  },
  {
    url: '/mock/get/market/sectorPerformance',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          page: 1,
          pageSize: 10,
          finished: true,
          list: [
            { name: '新能源', changeRate: 2.35, stocks: 156, topStock: '宁德时代' },
            { name: '半导体', changeRate: 1.89, stocks: 98, topStock: '中芯国际' },
            { name: '医药生物', changeRate: -0.65, stocks: 234, topStock: '恒瑞医药' },
            { name: '消费电子', changeRate: 1.23, stocks: 87, topStock: '立讯精密' },
            { name: '金融', changeRate: 0.45, stocks: 45, topStock: '中国平安' },
            { name: '房地产', changeRate: -1.23, stocks: 123, topStock: '万科A' },
            { name: '食品饮料', changeRate: 0.89, stocks: 67, topStock: '贵州茅台' },
            { name: '汽车', changeRate: 1.56, stocks: 89, topStock: '比亚迪' },
          ],
        },
      }
    },
  },
  {
    url: '/mock/get/market/hkOverview',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          hsiIndex: { name: '恒生指数', code: 'HSI.HK', price: 8895.12, change: -13.98, changeRate: -0.16 },
          hsceIndex: { name: '恒生国企', code: 'HSCEI.HK', price: 25816.93, change: 44.79, changeRate: 0.10 },
          hstIndex: { name: '恒生科技', code: 'HSTECH.HK', price: 5473.30, change: 10.41, changeRate: 0.33 },
        },
      }
    },
  },
  {
    url: '/mock/get/market/warrants',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          index: { name: '恒生指数', code: 'HSI.HK', price: 25818.93, change: 44.79, changeRate: 0.17 },
          list: [
            { name: '恒指中银六五沽A', code: '23152.HK', price: 0.096, changeRate: -3.00 },
            { name: '恒指法兴六五购A', code: '23153.HK', price: 0.125, changeRate: 2.45 },
            { name: '恒指汇丰六五购B', code: '23154.HK', price: 0.088, changeRate: -1.12 },
          ],
        },
      }
    },
  },
  {
    url: '/mock/get/market/capitalFlow',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          index: { name: '恒生指数', code: 'HSI.HK', price: 25818.93, change: 44.79, changeRate: 0.17 },
          list: [
            { name: '腾讯控股', code: '00700.HK', price: 385.20, changeRate: 1.25 },
            { name: '阿里巴巴', code: '09988.HK', price: 78.50, changeRate: -0.65 },
            { name: '美团', code: '03690.HK', price: 125.80, changeRate: 2.10 },
          ],
        },
      }
    },
  },
  {
    url: '/mock/get/market/brokerHoldings',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          chartData: [
            { date: '2025/11/13', holding: 1.07, index: 25724.44 },
            { date: '2025/11/20', holding: 2.15, index: 26100.20 },
            { date: '2025/11/27', holding: 3.42, index: 26450.80 },
            { date: '2025/12/04', holding: 4.18, index: 26800.15 },
            { date: '2025/12/11', holding: 5.25, index: 27050.60 },
            { date: '2025/12/18', holding: 6.36, index: 27304.66 },
          ],
          brokerName: '孙权夺妻',
        },
      }
    },
  },
  {
    url: '/mock/get/market/shortSellingList',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          updateTime: '2025-12-25',
          list: [
            { rank: 1, name: '协鑫科技', code: '03800.HK', value: '8767.99万', percent: 3.21 },
            { rank: 2, name: '中国儒意', code: '00136.HK', value: '-1006.58万', percent: 0.65 },
            { rank: 3, name: '地平线机器人\u2011W', code: '09660.HK', value: '8126.87万', percent: 4.26 },
          ],
        },
      }
    },
  },
  {
    url: '/mock/get/market/buyingList',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          updateTime: '2025-12-25',
          list: [
            { rank: 1, name: '协鑫科技', code: '03800.HK', value: '8767.99万', percent: 3.21 },
            { rank: 2, name: '中国儒意', code: '00136.HK', value: '-1006.58万', percent: 0.65 },
            { rank: 3, name: '地平线机器人\u2011W', code: '09660.HK', value: '8126.87万', percent: 4.26 },
          ],
        },
      }
    },
  },
  {
    url: '/mock/get/market/anomalyRadar',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          updateTime: '2025-12-25',
          list: [
            { name: '协鑫科技', code: '03800.HK', action: '大手买入', volume: '53.00万股' },
            { name: '协鑫科技', code: '03800.HK', action: '大手买入', volume: '53.00万股' },
            { name: '协鑫科技', code: '03800.HK', action: '大手买入', volume: '53.00万股' },
          ],
        },
      }
    },
  },
  {
    url: '/mock/get/market/sectorList',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          updateTime: '2025-12-25',
          list: [
            { name: '原材料', trend: 'down' },
            { name: '玩具及消闲', trend: 'down' },
            { name: '建筑', trend: 'down' },
          ],
        },
      }
    },
  },
  {
    url: '/mock/get/market/hkConnect/summary',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          sh: { title: '港股通(沪)', netBuy: -5.52, remainingQuota: 0, stockCount: 588 },
          sz: { title: '港股通(深)', netBuy: -6.24, remainingQuota: 0, stockCount: 588 },
        },
      }
    },
  },
  {
    url: '/mock/get/market/hkConnect/netBuySell',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          date: '2025-12-25',
          rows: [
            { period: '近5日', sh: -39.79, sz: 111.69 },
            { period: '近20日', sh: -107.73, sz: 415.70 },
            { period: '近60日', sh: 1164.48, sz: 1697.39 },
          ],
          chart: {
            x: ['2025/11/13', '2025/11/20', '2025/11/27', '2025/12/04', '2025/12/11', '2025/12/18', '2025/12/24'],
            series: [
              { name: '港股通', color: '#ff8c00', data: [1.07, 6.36, 6.36, 2.18, 2.10, 2.05, 2.00] },
              { name: '港股通(沪)', color: '#3c78ff', data: [0.60, 1.20, 2.40, 3.10, 3.05, 3.02, 3.00] },
              { name: '港股通(深)', color: '#22a875', data: [0.30, 0.90, 1.80, 2.60, 2.55, 2.50, 2.45] },
              { name: '恒生指数', color: '#c5cfdc', data: [25724.44, 26100.20, 26450.80, 26800.15, 27050.60, 27304.66, 27111.00] },
            ],
          },
        },
      }
    },
  },
  {
    url: '/mock/get/market/hkConnect/capitalFlow',
    method: 'post',
    response: ({ body }: any) => {
      const { scope, days } = body || {}
      const key = `${scope ?? 'all'}-${days ?? '1'}`
      const baseRows = [
        { name: '长和', code: '00001.HK', netBuyShares: '2123.00', netCapitalIn: '94.94', netBuyRatio: '3232.00', b: '+78.00', c: 78 },
        { name: '中电控股', code: '00002.HK', netBuyShares: '233.30', netCapitalIn: '765.01', netBuyRatio: '32.00', b: '+107.21', c: 100 },
      ]
      return {
        error: '',
        status: 1,
        data: {
          date: '2025-12-25',
          key,
          rows: baseRows,
        },
      }
    },
  },
  {
    url: '/mock/get/getHKstockList/list',
    method: 'post',
    response: ({ body }) => {
      let list: any[] = []
      if (body.hold === 1) {
        list = [
          { stockName: '贵州茅台', stockCode: '600519', increasingBroker: '中信证券', proportion: 0.86, increasedShares: 268.00, per: 0.86, rate: +0.23, num: 1500, price: 1720.00, pre: +1.16 },
          { stockName: '宁德时代', stockCode: '300750', increasingBroker: '华泰证券', proportion: 1.23, increasedShares: 586.00, per: 1.45, rate: -0.52, num: 2800, price: 165.50, pre: -0.34 },
          { stockName: '比亚迪', stockCode: '002594', increasingBroker: '国泰君安证券', proportion: 0.97, increasedShares: 425.00, per: 2.12, rate: +1.45, num: 3200, price: 210.80, pre: +2.10 },
          { stockName: '中国平安', stockCode: '601318', increasingBroker: '海通证券', proportion: 1.56, increasedShares: 892.00, per: 0.65, rate: -0.12, num: 5400, price: 42.30, pre: -0.05 },
          { stockName: '招商银行', stockCode: '600036', increasingBroker: '广发证券', proportion: 0.72, increasedShares: 364.00, per: 0.42, rate: +0.33, num: 4100, price: 31.15, pre: +0.22 },
          { stockName: '立讯精密', stockCode: '002475', increasingBroker: '兴业证券', proportion: 0.68, increasedShares: 298.00, per: 1.88, rate: +2.56, num: 2300, price: 28.90, pre: +1.45 },
          { stockName: '隆基绿能', stockCode: '601012', increasingBroker: '中信建投证券', proportion: 1.18, increasedShares: 513.00, per: 3.24, rate: -1.22, num: 6700, price: 18.45, pre: -2.10 },
          { stockName: '贵州白药', stockCode: '000538', increasingBroker: '申万宏源', proportion: 0.59, increasedShares: 186.00, per: 0.35, rate: +0.15, num: 1200, price: 51.20, pre: +0.08 },
          { stockName: '东方财富', stockCode: '300059', increasingBroker: '国信证券', proportion: 1.34, increasedShares: 679.00, per: 4.15, rate: +3.12, num: 8900, price: 12.55, pre: +2.88 },
          { stockName: '伊利股份', stockCode: '600887', increasingBroker: '华泰联合证券', proportion: 0.45, increasedShares: 152.00, per: 0.55, rate: -0.45, num: 3300, price: 26.70, pre: -0.12 },
          { stockName: '迈瑞医疗', stockCode: '300760', increasingBroker: '安信证券', proportion: 0.89, increasedShares: 237.00, per: 0.92, rate: +1.10, num: 900, price: 285.00, pre: +0.55 },
          { stockName: '万科A', stockCode: '000002', increasingBroker: '中泰证券', proportion: 1.05, increasedShares: 741.00, per: 2.10, rate: -2.35, num: 7500, price: 7.20, pre: -1.45 },
        ]
      }
      else {
        list = [
          { stockName: '宜宾五粮液', stockCode: '000858', increasingBroker: '中国银河证券', proportion: 0.78, increasedShares: 325.00, per: 1.12, rate: +0.85, num: 2100, price: 145.20, pre: +0.65 },
          { stockName: '美的集团', stockCode: '000333', increasingBroker: '光大证券', proportion: 1.12, increasedShares: 489.00, per: 0.75, rate: +0.42, num: 3400, price: 62.15, pre: +0.15 },
          { stockName: '深信服科技', stockCode: '300454', increasingBroker: '华泰证券', proportion: 0.65, increasedShares: 198.00, per: 2.45, rate: -3.12, num: 1200, price: 55.40, pre: -2.80 },
          { stockName: '中国工商银行', stockCode: '601398', increasingBroker: '中信证券', proportion: 0.42, increasedShares: 956.00, per: 0.15, rate: +0.05, num: 9800, price: 5.34, pre: +0.02 },
          { stockName: '博世科', stockCode: '300457', increasingBroker: '国泰君安证券', proportion: 1.35, increasedShares: 215.00, per: 3.12, rate: +5.20, num: 4500, price: 6.88, pre: +4.15 },
          { stockName: '爱尔眼科', stockCode: '300015', increasingBroker: '海通证券', proportion: 0.56, increasedShares: 172.00, per: 1.65, rate: -1.45, num: 3100, price: 11.25, pre: -0.95 },
          { stockName: '长江电力', stockCode: '600900', increasingBroker: '广发证券', proportion: 0.89, increasedShares: 638.00, per: 0.28, rate: +0.12, num: 5600, price: 25.40, pre: +0.05 },
          { stockName: '中联重科', stockCode: '000157', increasingBroker: '兴业证券', proportion: 0.96, increasedShares: 375.00, per: 1.42, rate: +0.95, num: 4200, price: 7.12, pre: +0.45 },
          { stockName: '珠海格力电器', stockCode: '000651', increasingBroker: '中信建投证券', proportion: 0.38, increasedShares: 521.00, per: 0.88, rate: -0.25, num: 2900, price: 38.50, pre: -0.10 },
          { stockName: '江苏恒瑞医药', stockCode: '600276', increasingBroker: '申万宏源', proportion: 1.28, increasedShares: 264.00, per: 1.15, rate: +2.15, num: 1800, price: 44.30, pre: +1.85 },
        ]
      }
      return {
        error: '',
        status: 1,
        data: {
          page: 1,
          pageSize: 10,
          finished: true,
          list,
        },
      }
    },
  },
  {
    url: '/mock/get/market/mainland/overview',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: [
          { name: '上证50ETF', price: 3.105, change: -0.003, changeRate: -0.10 },
          { name: '沪深300ETF', price: 4.523, change: -0.012, changeRate: -0.26 },
          { name: '创业板ETF', price: 1.856, change: -0.005, changeRate: -0.27 },
        ],
      }
    },
  },
  {
    url: '/mock/get/market/mainland/sectorPerformance',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: [
          { name: '航空航天', changeRate: 2.96 },
          { name: '计算机', changeRate: 1.85 },
          { name: '通信', changeRate: 1.72 },
          { name: '电子', changeRate: 1.58 },
          { name: '医药生物', changeRate: 1.45 },
          { name: '化工', changeRate: 1.32 },
          { name: '机械设备', changeRate: 1.21 },
          { name: '电气设备', changeRate: 1.15 },
          { name: '汽车', changeRate: 1.08 },
        ],
      }
    },
  },
  {
    url: '/mock/get/market/mainland/stockRanking',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: [
          { name: 'N新广益', code: '301687.HK', price: 71.32, changeRate: 225.22 },
          { name: 'N新广益', code: '301687.HK', price: 71.32, changeRate: 225.22 },
          { name: 'N新广益', code: '301687.HK', price: 71.32, changeRate: 225.22 },
          { name: 'N新广益', code: '301687.HK', price: 71.32, changeRate: 225.22 },
        ],
      }
    },
  },
  {
    url: '/mock/get/market/stock/detail',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          name: '沪港通南向',
          code: 'HKDQB.SH',
          price: 42000.00,
          change: 0.00,
          changeRate: 0.00,
          open: '--',
          prevClose: 42000.00,
          high: '--',
          low: '--',
          volume: '--',
          amplitude: '--',
          updateTime: '12-26 09:01:38',
        },
      }
    },
  },
  {
    url: '/mock/get/market/stock/components',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: [
          {
            name: '百奥赛图 - B',
            code: '02315.HK',
            price: 35.080,
            changeRate: 22.23,
            isFavorite: false,
          },
          {
            name: '百奥赛图 - B',
            code: '02315.HK',
            price: 35.080,
            changeRate: 22.23,
            isFavorite: false,
          },
          {
            name: '百奥赛图 - B',
            code: '02315.HK',
            price: 35.080,
            changeRate: 22.23,
            isFavorite: true,
          },
        ],
      }
    },
  },
])
